@charset "UTF-8";
.settingsHeading {
  color: var(--globalText);
  font-size: 16px;
  margin-bottom: 10px;
  margin-inline-start: 0;
  margin-inline-end: 0;
  margin-top: 10px;
  padding-inline-start: 30px;
  padding-inline-end: 30px;
}

.settingsSeparator {
  background-color: rgba(0, 0, 0, 0.05);
  border: 0;
  height: 5px;
  margin-bottom: 15px;
  margin-inline-start: 0;
  margin-inline-end: 0;
  margin-top: 15px;
}

.settingsEndSeparator {
  background-color: transparent;
  border: 0;
  height: 0;
  margin-bottom: 20px;
  margin-inline-start: 0;
  margin-inline-end: 0;
  margin-top: 0;
}

.settingsButton {
  background-color: transparent;
  border: 0;
  color: var(--globalText);
  min-height: 40px;
  padding-inline-start: 30px;
  padding-inline-end: 30px;
  text-align: inherit;
  width: 100%;
}
.settingsButton:hover {
  background-color: var(--chatListItemBgHover);
  cursor: pointer;
}
.settingsButton.highlight {
  color: var(--colorPrimary);
  font-weight: bold;
}

.settingsIconButton {
  align-items: center;
  background-color: unset;
  border: none;
  cursor: pointer;
  display: flex;
  height: 40px;
  padding-bottom: 0;
  padding-inline-start: 30px;
  padding-inline-end: 30px;
  padding-top: 0;
  width: 100%;
}
.settingsIconButton:hover, .settingsIconButton:focus {
  background-color: var(--chatListItemBgHover);
}
.settingsIconButton.active {
  background-color: var(--chatListItemSelectedBg);
}
.settingsIconButton.active:hover, .settingsIconButton.active:focus {
  background-color: var(--chatListItemSelectedBg);
}
.settingsIconButton.active .settingsIconButtonLabel {
  color: var(--chatListItemSelectedText);
}
.settingsIconButton.active > span:not(.settingsIconButtonLabel) {
  background-color: var(--chatListItemSelectedText);
}

/* Two-pane settings layout (wide viewports): navigation sidebar on the
   left, the selected section in a pane on the right — no stacked
   section dialogs. */
.settingsTwoPane {
  display: flex;
  flex: 1 1 auto;
  min-height: 0;
}

.settingsSidebar {
  background-color: rgba(0, 0, 0, 0.03);
  border-inline-end: 1px solid rgba(0, 0, 0, 0.1);
  flex-shrink: 0;
  overflow-y: auto;
  padding-top: 20px;
  width: 300px;
}
.settingsSidebar .profile > div:first-child {
  flex-basis: 72px;
  height: 72px;
  width: 72px;
}
.settingsSidebar .profile > div:first-child img,
.settingsSidebar .profile > div:first-child span {
  font-size: 46px;
  height: 72px;
  width: 72px;
}

.settingsPane {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  min-width: 0;
  padding-top: 20px;
}

.settingsIconButtonLabel {
  color: var(--globalText);
  flex-grow: 1;
  line-height: 2;
  margin-inline-start: 20px;
  text-align: start;
}

.settingsSelector {
  background: none;
  color: inherit;
  border: none;
  padding: 0;
  font: inherit;
  text-align: inherit;
  width: 100%;
}

.settingsRow {
  align-items: center;
  cursor: pointer;
  display: flex;
  min-height: 40px;
  justify-content: space-between;
  padding-bottom: 10px;
  padding-inline-start: 30px;
  padding-inline-end: 30px;
  padding-top: 10px;
  user-select: none;
}
.settingsRow:hover {
  background-color: var(--chatListItemBgHover);
}

.micTestResult {
  padding: 0 30px 10px;
}

.settingsSelectorValue {
  color: var(--colorPrimary);
  font-weight: lighter;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 33.33333%;
  flex-shrink: 0;
}

.settingsRowLeft {
  display: flex;
  flex-direction: column;
  margin-inline-end: 15px;
}

.settingsRowLabel {
  color: var(--globalText);
}
.settingsRowLabel.disabled {
  color: rgba(92, 112, 128, 0.6);
}

.settingsRowDescription {
  color: var(--chat-list-item-archived-label-border);
  font-size: smaller;
  margin-top: 3px;
}
.settingsRowDescription.disabled {
  color: rgba(92, 112, 128, 0.6);
}

.forkBadge {
  cursor: help;
  font-size: 12px;
  margin-inline-start: 6px;
  opacity: 0.75;
}

.settingsRowRight {
  align-items: center;
  display: flex;
}

.profile {
  display: flex;
  cursor: pointer;
  padding: 10px 25px;
  width: 100%;
  border: none;
  background-color: transparent;
  text-align: start;
}
.profile:hover, .profile:focus {
  background-color: var(--chatListItemBgHover);
}

.profileDetails {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-inline-start: 20px;
  overflow: hidden;
}

.profileDisplayName {
  font-size: 18px;
  font-weight: 200;
}

.profileBio {
  margin-top: 5px;
  overflow: hidden;
  text-wrap-mode: nowrap;
  text-overflow: ellipsis;
  opacity: 0.6;
}